import {RootStore} from '../../stores/RootStore';
import {PanoramaTransactions} from '../../../../constants/app';
import {getCtaButtonClickHandler} from './getCtaButtonClickHandler';
import {WidgetEventHandler} from './types';
import {createCheckout} from '../createCheckout';
import {interruptAction} from './interruptAction';

export const handleBuyNowClick = (rootStore: RootStore): WidgetEventHandler<any> => {
  return getCtaButtonClickHandler(rootStore, () => {
    const action = () =>
      rootStore.reportPanoramaTransaction(PanoramaTransactions.BuyNow, () =>
        createCheckout(rootStore, {withNavigateToCheckout: true}).then(() => Promise.resolve()),
      );

    return interruptAction(rootStore.wixCodeService.onBuyNowInterruption, action);
  });
};
